import React from 'react';

import AddUserToRoleForm from './AddUserToRoleForm';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import { useRoleShowState, useRoleShowActions } from './RoleShowContext';

import styles from './RoleModal.module.scss';

const AddUserToRoleModal = ({ role }) => {
  const state = useRoleShowState();
  const { closeAddUserToRoleModal } = useRoleShowActions();

  return (
    <StandardModal
      isOpen={state?.addUserToRoleModalIsOpen}
      onRequestClose={() => {
        closeAddUserToRoleModal();
      }}
    >
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>
          Add User to Role
        </h2>
        <AddUserToRoleForm role={role} />
      </section>
    </StandardModal>
  );
};

export default AddUserToRoleModal;
